import { FunctionComponent, useMemo } from 'react';
import { PublicCourse, PublicEducator } from '@cademy-package/sdk-component-types';
import ButtonLink from '../../../ButtonLink';
import styles from './styles.module.scss';
import useEmbedExternalLinkProps from '../../../../hooks/useEmbedExternalLinkProps';
import { useMinisiteLink } from '../../../../hooks/useMinisiteLink';
import { getEnquiryUrl } from '../../../../services/getEnquiryUrl';
import { useIsMarketplace } from '../../../../contexts/AppContext/useIsMarketplace';

type SecondaryButtonsProps = {
    course: PublicCourse;
    educator: PublicEducator;
    isEmbed: boolean;
};

export const SecondaryButtons: FunctionComponent<SecondaryButtonsProps> = ({
    course,
    educator,
    isEmbed,
}) => {
    const isMarketplace = useIsMarketplace();

    const contactUsUrl = useMemo(() => {
        return getEnquiryUrl({
            course,
            educator,
            isMarketplace,
            isEmbed,
        });
    }, [course, educator, isEmbed, isMarketplace]);

    return (
        <ButtonLink href={contactUsUrl} className={styles.contactAndMoreBtn}>
            Contact Us
        </ButtonLink>
    );
};
